// Used for GTA tracking

export enum ContactSteps {
  CUSTOMIZE,
  QUOTE,
  CONFIRM,
}
